import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  generalMusicSchema,
  streamDataSchema,
} from "../../../ZodSchemas/MusicSchema";
import { musicService } from "../../../services";
import GeneralMusicData from "../../../components/EditMusic";
import StreamData from "../../../components/admin/StreamingEdit";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";

const MusicUpdateForm = () => {
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating]= useState(false)
  const [error, setError]= useState(false)
  const [errorMessage, setErrorMessage]= useState(null)

  const {id}=useParams()
  const methods = useForm({
    resolver: zodResolver(
      generalMusicSchema.merge(z.object({ streams: streamDataSchema }))
    ),
  });
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  useEffect(() => {
    const fetchMusic = async () => {
      setError(false)
      try {
        let music=await musicService.singleMusic(id)   
        music = {
          ...music,
          releaseDate:music.releaseDate.split("T")[0],
          genre: music.genre.join(", "),
          featuredArtiste: music.featuredArtiste?.join(", ") || "",
        };
        Object.keys(music).forEach((key) => setValue(key, music[key]));
      } catch (error) {
        setError(true)
        console.error("Failed to fetch music data", error);
      }finally{
        setLoading(false)
      }
    };
    fetchMusic();
  }, [id, setValue]);

  const onSubmit = async (data) => {
    setUpdating(true);
    setError(false)
    setErrorMessage(null)
    try {
      await musicService.updateMusic(id, data)
    } catch (error) {
      setError(true)
      setErrorMessage({title:"Updating", message:"update"})
    } finally {
     setUpdating(false)
    }
  };

  if (loading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>;
  if (error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={`Error ${errorMessage?.title ||"Fetching"} Music`} message={`There is error while trying to ${errorMessage?.message ||"fetch"} the music details. Please check your internet contivities and refresh this page to try again`} />;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="mb-4">
        <h1 className="text-xl capitalize font-bold mb-4">Update Music</h1>
        <GeneralMusicData errors={errors} />
        <StreamData />
        <button type="submit" className="formSubmitBtn" disabled={updating}>
          {updating ? "Updating..." : "Update Music"}
        </button>
      </form>
    </FormProvider>
  );
};

export default MusicUpdateForm;